import { BrowserModule } from '@angular/platform-browser';
import { NgModule,inject } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from "@auth0/angular-jwt";
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { SearchResultComponent } from './modules/search/components/search-result.component';
import { CategoryService } from './modules/products/services/category.service';
import { Payments } from './modules/cart/models/payments.model';
import { FormsModule } from '@angular/forms';
import { OrdersComponent } from './modules/order/components/orders.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Globals } from './shared/global/globals';
import { OwlModule } from 'ngx-owl-carousel';
import { ServicesCalendarComponent } from './modules/services-calendar/components/services-calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { initializeApp } from "firebase/app";
import { environment } from 'src/environments/environment';
initializeApp(environment.firebase);
@NgModule({
  declarations: [
    AppComponent,
    SearchResultComponent,
    OrdersComponent,
  ],
  imports: [
    OwlModule,
    TranslateModule.forRoot({
    }),
    MatCarouselModule.forRoot(),
    BrowserModule,
    NgxLoadingModule.forRoot({}),
    FormsModule,
    BrowserAnimationsModule,
    SharedModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    MatFormFieldModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    
  ],
  providers: [
    CategoryService,
    Payments,
    Globals
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function tokenGetter() {
  return localStorage.getItem("jwt");
}
